<template>
  <div class="cl-inner">
    <div v-show="this.$route.path == '/expenseMangement'">
      <div class="search">
        <a-select
          v-model="queryParam.termId"
          class="form-cell"
          placeholder="请选择学期"
        >
          <a-select-option
            v-for="item in termList"
            :key="item.id"
            :value="item.id"
            >{{ item.termName }}</a-select-option
          >
        </a-select>
        <a-form layout="inline" style="margin-top: 20px">
          <!-- 审核单号 -->
          <a-form-item class="name" label="审核单号">
            <a-input-number
              class="form-cell"
              placeholder="请输入"
              v-model="queryParam.accountExpenseId"
            ></a-input-number>
          </a-form-item>
          <!-- 费用类型 -->
          <a-form-item class="name" label="费用类型">
            <a-select
              placeholder="请选择"
              style="width: 200px"
              v-model="queryParam.expenseType"
            >
              <a-select-option
                v-for="item in expenseTypeList"
                :key="item.id"
                :value="item.id"
                >{{ item.expenseName }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button class="mr15" type="primary" @click="search('')"
              >查询</a-button
            >
            <a-button type="primary" @click="reset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="mt20">
        <a-button
          type="primary"
          @click="
            $router.push({
              name: 'addExpense',
              query: { is: 'add' },
            })
          "
        >
          <a-icon type="plus" />
          新建
        </a-button>
      </div>
      <div class="mt20">
        <a-button class="mr15" type="primary" @click="search('')"
          >全部({{ expenseStatusCount.statusTotal }})</a-button
        >
        <a-button class="mr15" type="primary" @click="search(-1)"
          >待提交({{ expenseStatusCount.statusDraft }})</a-button
        >
        <a-button class="mr15" type="primary" @click="search(0)"
          >待审核({{ expenseStatusCount.statusReview }})</a-button
        >
        <a-button class="mr15" type="primary" @click="search(1)"
          >审核通过({{ expenseStatusCount.statusPass }})</a-button
        >
        <a-button class="mr15" type="primary" @click="search(3)"
          >审核不通过({{ expenseStatusCount.statusRejected }})</a-button
        >
        <a-button class="mr15" type="primary" @click="search(2)"
          >已完成({{ expenseStatusCount.statusPaid }})</a-button
        >
      </div>
      <div class="mt20">
        <a-button class="mr15" type="primary" @click="batchSubmit('')"
          >批量提交</a-button
        >
        <a-button class="mr15" type="primary" @click="batchDelete('')"
          >批量删除</a-button
        >
      </div>
      <a-table
        class="mt20"
        :columns="columns"
        :dataSource="expenseList"
        :pagination="pagination"
        :loading="loading"
        @change="tableChange"
        :rowKey="getRowKey"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :hideDefaultSelections="true"
      >
        <span slot="amount" slot-scope="text">
          {{ text ? text : 0 }}
        </span>
        <span slot="paymentProof" slot-scope="text, record">
          {{ record.approveStatusText == '已完成' && text ? '已上传' : '-' }}
        </span>
        <span slot="remark" slot-scope="text, record">
          <template>
            <a :title="record.remark" style="color: #000000a6">{{
              record.remark
            }}</a>
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a v-if="record.approveStatus == -1" @click="batchSubmit(record.id)"
              >提交 &nbsp;&nbsp;</a
            >
            <a
              v-if="record.approveStatus == -1"
              @click="
                $router.push({
                  name: 'addExpense',
                  query: { is: 'update', record },
                })
              "
              >修改 &nbsp;&nbsp;</a
            >
            <a v-if="record.approveStatus == -1" @click="batchDelete(record.id)"
              >删除 &nbsp;&nbsp;</a
            >
            <a
              v-if="record.approveStatus != -1"
              @click="
                $router.push({
                  name: 'addExpense',
                  query: { expenseId: record.id, is: 'check' },
                })
              "
              >查看</a
            >
          </template>
        </span>
      </a-table>
      <a-modal
        :width="700"
        :maskClosable="false"
        :confirm-loading="confirmLoading"
        title="提交审核"
        @ok="handleOk"
        v-model="visible"
      >
        <div>
          <p style="font-size: 16px">操作说明：</p>
          <a-textarea
            v-model="operationDesc"
            style="margin-top: 15px"
            :max-length="500"
            :auto-size="{ minRows: 10, maxRows: 15 }"
          ></a-textarea>
        </div>
      </a-modal>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import finOrder from '../../api/finOrder'
const columns = [
  {
    title: '审核单号',
    dataIndex: 'id',
    width: 100,
  },
  {
    title: '学期',
    width: 150,
    dataIndex: 'termText',
  },
  {
    title: '费用类型',
    dataIndex: 'expenseTypetext',
    width: 100,
  },
  {
    title: '金额',
    scopedSlots: { customRender: 'amount' },
    dataIndex: 'amount',
    width: 100,
  },
  {
    title: '费用备注',
    scopedSlots: { customRender: 'remark' },
    ellipsis: true,
    width: 100,
    dataIndex: 'remark',
  },
  {
    title: '状态',
    dataIndex: 'approveStatusText',
    width: 100,
  },
  {
    title: '打款凭证',
    dataIndex: 'paymentProof',
    scopedSlots: { customRender: 'paymentProof' },
    width: 100,
  },
  {
    title: '创建时间',
    dataIndex: 'created',
    width: 170,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 170,
  },
]
export default {
  data() {
    return {
      queryParam: {
        termId: 0,
        accountExpenseId: null,
        expenseType: null,
        approveStatus: '',
      },
      columns,
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      expenseList: [{ aa: 1, bb: 2, cc: 3, dd: 4, ee: 5, ff: 6, gg: 7, hh: 8 }],
      loading: false,
      selectedRowKeys: [], //选中数组
      record: [], //选中数组
      termList: [], //学期数组
      expenseTypeList: [], //费用类型数组
      expenseStatusCount: {}, //全部，待提交...数量显示
      visible: false, //弹框显示
      confirmLoading: false, //弹框确定按钮loading
      operationDesc: '', //操作说明字段
      atId: '', //当前提交或修改的id
    }
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    if (!this.queryParam.termId) {
      this.queryParam = { ...this.queryParam, termId: 0 }
    }

    this.getExpenseList(this.queryParam)
  },
  methods: {
    //重置
    reset() {
      this.queryParam = { termId: 0 }
      // this.getExpenseList(this.queryParam)
    },
    //查询
    search(status) {
      var queryParams = JSON.parse(JSON.stringify(this.queryParam))
      queryParams.page = 0
      queryParams.size = 10
      queryParams.approveStatus = status
      this.queryParam.approveStatus = status
      this.pagination.currentPage = 1
      this.pagination.current = 1
      this.pagination.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        queryParams
      )}`
      this.getExpenseList({ ...queryParams, approveStatus: status })
    },
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      this.pagination.currentPage = pagination.current
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      let obj = JSON.parse(JSON.stringify(this.queryParam))
      obj.page = pagination.current - 1
      obj.size = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      // if (sorter && sorter.columnKey) {
      //   obj.sorter = `${sorter.columnKey}-${
      //     sorter.order == 'ascend' ? 'asc' : 'desc'
      //   }`
      // }
      console.log('obj', obj)
      this.getExpenseList({
        ...obj,
        approveStatus: this.queryParam.approveStatus,
      })
    },
    //获取费用管理列表
    getExpenseList(params) {
      console.log('params', params)
      this.loading = true
      finOrder
        .expenseApplication(params)
        .then((res) => {
          this.loading = false

          if (res.page) {
            this.expenseList = res.page.content
            this.pagination.total = res.page.totalElements
          } else {
            this.expenseList = []
            this.pagination.total = 0
          }
          this.expenseStatusCount = res.expenseStatusCount[0]
          this.termList = res.teaTerms
          this.expenseTypeList = res.expenseType
          this.pagination.current = res.page.pageable.pageNumber + 1
          this.pagination.currentPage = res.page.pageable.pageNumber + 1
          this.pagination.pageSize = res.page.pageable.pageSize
        })
        .finally((res) => {
          this.loading = false
        })
    },
    getRowKey(record, index) {
      return index;
    },
    //批量提交
    batchSubmit(id) {
      console.log('this.record.length', this.record.length)
      console.log('id', id)
      if (this.record.length) {
        let a = this.record.every((item) => item.approveStatus == -1)
        if (a) {
          this.visible = true
        } else {
          this.$message.error('请选择‘待提交’状态数据进行批量提交')
        }
      } else if (id) {
        this.atId = id
        this.visible = true
      } else {
        this.$message.error('请勾选数据')
      }
    },
    //批量提交弹框按钮
    handleOk() {
      this.confirmLoading = true
      let a = []
      if (this.record.length) {
        a = this.record.map((item) => item.id)
      } else {
        a.push(this.atId)
      }
      finOrder
        .batchSubmitRequest({ ids: a, operationDesc: this.operationDesc })
        .then((res) => {
          this.visible = false
          this.confirmLoading = false
          this.$message.success('操作成功')
          this.record = []
          this.selectedRowKeys = []
          this.operationDesc = ''
          this.getExpenseList(this.queryParam)
        })
    },
    //批量删除
    batchDelete(id) {
      if (this.record.length) {
        let a = this.record.every((item) => item.approveStatus == -1)
        if (a) {
          let b = this.record.map((item) => item.id)
          let self = this
          this.$confirm({
            title: '确定要删除吗?',
            okText: '确定',
            cancelText: '取消',
            content: '删除后，无法撤销',
            onOk() {
              finOrder.deleteExpenseRequest({ ids: b }).then((res) => {
                self.$message.success('操作成功')
                self.record = []
                self.selectedRowKeys = []
                self.getExpenseList(self.queryParam)
              })
            },
          })
        } else {
          this.$message.error('请选择‘待提交’状态数据进行批量删除')
        }
      } else if (id) {
        let b = []
        b.push(id)
        let self = this
        this.$confirm({
          title: '确定要删除吗?',
          okText: '确定',
          cancelText: '取消',
          content: '删除后，无法撤销',
          onOk() {
            finOrder.deleteExpenseRequest({ ids: b }).then((res) => {
              self.$message.success('操作成功')
              self.getExpenseList(self.queryParam)
            })
          },
        })
      } else {
        this.$message.error('请勾选数据')
      }
    },
    onSelectChange(selectedRowKeys, record) {
      this.selectedRowKeys = selectedRowKeys
      this.record = record
    },
    add() {
      console.log('新增')
      this.$router.push({
        name: 'addExpense',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.mt20 {
  margin-top: 20px;
}
.mr15 {
  margin-right: 15px;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
/deep/ .ant-empty-normal {
  margin: 10px 0;
}
/deep/ .ant-table-placeholder {
  padding: 0 16px;
}
</style>
